import { Maybe } from 'gql'
import { language } from './language'

export const formatAmount = ({
  cents,
  minimumFractionDigits,
  skipCurrency,
}: {
  cents: Maybe<number> | undefined
  minimumFractionDigits?: number
  skipCurrency?: boolean
}) => {
  const intlSupport = !!(typeof Intl == 'object' && Intl && typeof Intl.NumberFormat == 'function')

  cents ||= 0

  if (intlSupport) {
    const params = {
      minimumFractionDigits: minimumFractionDigits || (cents % 100 === 0 ? 0 : 2),
    }
    if (!skipCurrency) {
      Object.assign(params, {
        style: 'currency',
        currency: 'EUR',
      })
    }
    return new Intl.NumberFormat(language(), params).format(cents / 100)
  } else {
    let result = (cents / 100)
      .toFixed(cents % 100 === 0 ? 0 : 2)
      .replace('.', ',')
      .replace(/\d(?=(\d{3})+,)/g, '$&.')
    if (!skipCurrency) {
      result += '\u00a0€'
    }
    return result
  }
}

export const parseCents = (sanitizedAmount: string) => {
  if (sanitizedAmount == '') return 0
  const floatText = sanitizedAmount.toString().replace(',', '.')
  const cents = parseFloat(floatText) || 0
  return Math.round(cents * 100)
}

const MAXIMUM_CENTS = 999900

export const limitCents = (cents: number) => (cents < MAXIMUM_CENTS ? cents : MAXIMUM_CENTS)

export const sanitizeMoney = (value: string) => {
  return value
    .replace(/[^\d.,]/g, '') // drop anything except digits, dots and commas
    .replace(/^[.,]+/, '') // drop any leading dot and comma
    .replace(/^0{2,}/, '0') // limit to one leading 0
    .replace(/[.,]([^.,]*)(?=[.,])/g, '$1') // drop any dots and commas except the last one
    .replace(/([.,]\d\d).*$/, '$1') // limit to two decimal places
}
